import { motion } from "motion/react";

const VIDEO_URL = "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260429_114316_1c7889ad-2885-410e-b493-98119fee0ddb.mp4";

export const Hero = () => {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
      <video
        src={VIDEO_URL}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="hero-video"
      />

      <div className="absolute inset-0 bg-black/55" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-[#0A0908]" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center py-32">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2, ease: "easeOut" }}
          className="text-xs md:text-sm uppercase tracking-[0.35em] text-[#C6A15B] mb-6"
          data-testid="hero-eyebrow"
        >
          Barinas Heritage Global
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
          className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-medium text-white leading-tight mb-6"
          data-testid="hero-title"
        >
          Convertimos el potencial en estructura.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6, ease: "easeOut" }}
          className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed"
          data-testid="hero-subtitle"
        >
          Somos el puente entre la riqueza de Barinas y las necesidades del mundo:
          diseñamos el método, orquestamos los proyectos y abrimos la puerta para que se sume.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8, ease: "easeOut" }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            href="#servicios"
            data-testid="hero-cta-primary"
            className="inline-flex items-center justify-center rounded-full bg-[#C6A15B] px-8 py-3.5 text-sm uppercase tracking-widest text-black font-medium hover:bg-[#d9b876] transition-colors"
          >
            Aliarse con BHG
          </a>
          <a
            href="#participa"
            data-testid="hero-cta-secondary"
            className="liquid-glass inline-flex items-center justify-center rounded-full px-8 py-3.5 text-sm uppercase tracking-widest text-white hover:text-[#C6A15B] transition-colors bg-white/5"
          >
            Súmese al desarrollo de Barinas
          </a>
        </motion.div>
      </div>
    </section>
  );
};
